import React from 'react'
import { centerContentOnMobile } from '../../styles/media-queries'
import styled from 'styled-components'
import { AppBar, Box, Button, Grid, CircularProgress } from '@material-ui/core'
import colors from '../../shared/constants/colors'

const BottomAppBar = styled(AppBar)`
  background-color: ${colors.backgroundGray};
  bottom: 0;
  height: auto;
  padding: 11px 0px;
  top: auto;
  box-shadow: none;
`

const InnerGrid = styled(Grid)`
  margin: auto;
  max-width: 1280px;
`

const FormActions = ({ isValid, isSubmitting, back, step }) => {
  const mobileCenterStyles = centerContentOnMobile()

  return (
    <Box pt={2} mt={5} borderTop={1} borderColor="grey.300">
      <BottomAppBar position="static" style={{ width: '100%', height: '100%' }}>
        <InnerGrid container alignItems="center" justify="space-between" className={mobileCenterStyles.root}>
          <Grid item className={mobileCenterStyles.root}>
            {step > 0 && (
              <Button variant="outlined" color="primary" size="small" style={{ width: 160 }} onClick={back}>
                Back
              </Button>
            )}
          </Grid>
          <Grid item className={mobileCenterStyles.root}>
            <Button
              type="submit"
              variant="contained"
              color="default"
              size="small"
              style={{ width: 160 }}
              disabled={!isValid}
            >
              {isSubmitting ? <CircularProgress size="1.2rem" /> : 'Next'}
            </Button>
          </Grid>
        </InnerGrid>
      </BottomAppBar>
    </Box>
  )
}

export default FormActions
